export default {
  evaluationsTitle: 'Evaluations:',
  evaluationsPrintTitle: 'Evaluations - {code} {name}',
  evaluations: 'Evaluations',
  evaluationXLSX: 'Evaluation XLSX',
  evaluationType: 'Evaluation type',
  learningOutcome: 'Learning result',
  achievementIndicators: 'Achievement Indicators',
  evaluativeSituation: 'Evaluative situation',
  authenticEvaluation: 'Authentic Evaluation',
  evaluationDescription: 'Evaluation description',
  evaluationDescriptionTooltip: 'Evaluation description (Mention the main characteristics that configure the evaluation activity: main characteristics of the assignment, practical execution, written tests or presentation)',
  connectionWithEnvironment: 'Connection with the Environment',
  evaluativeAgent: 'Evaluative agent',
  evaluationWeighting: 'Evaluation weighting',
  weightingByEvaluativeSituation: 'Weighting by evaluative situation',
  directedTeachingHours: 'Directed Teaching Hours (pedagogical)',
  autonomousWorkHours: 'Autonomous Work Hours Preparation and/or Execution (chronological)',
  workType: 'Work type',
  environment: 'Environment',
  examiner: 'Examiner',
  avaLiberationWeek: 'AVA Liberation Week',
  hrs: 'Hrs.',
}
